import { Component, OnInit, AfterViewInit, HostListener } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { NgbCalendar, NgbDatepickerConfig } from '@ng-bootstrap/ng-bootstrap';
import { Router, ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs';
import { ToastrService } from 'ngx-toastr';
import * as $ from 'jquery';

//Service Class
import { LoaderService } from '../../../../services/infrastructure/loader.service';
import { BroadcastService } from '../../../../services/infrastructure/broadcaster.service';
import { ConfigService } from '../../../../services/infrastructure/config.service';
import { SeedReturnService } from '../../../../services/seed/seed-return.service';
import { LocalStorageService } from '../../../../services/infrastructure/local-storage.service';

//Class
import { DashboardFilter } from '../../../../models/DashboardFilter';
import { MasterConstants } from '../../../../common/constants/master-constants';
import { CommonService } from '../../../../services/common/common.service';

@Component({
  selector: 'app-seed-returns-approve-reject',
  templateUrl: './seed-returns-approve-reject.component.html',
  styleUrls: ['./seed-returns-approve-reject.component.scss']
})

export class SeedReturnsApproveRejectComponent implements OnInit, AfterViewInit {
  errorMsgs = new Array();
  showErrorBlock: boolean = false;
  currentErrorRow: number = 1;
  nextErrorId: number = 0;
  nextLotNumber: string;
  //Header selected values
  shipToAccount: number;
  deliveryAccount: number;
  deliveryAccountName: string;
  shipToAccountName: number;
  shipToAccountItems: any[];
  soldToAccount: number;
  headerCompany = MasterConstants.US_COMPANYCODE;
  cropYear: any;
  dashboardFilter: DashboardFilter;
  originalProductItemsDataSource: any;
  searchValue: string = "";
  partialSearchValue: string = "";
  //invoicedProductList: any = [];
  invoiceNumberList: any = [];
  productAllDataSource: any;
  displayedColumns: string[] = this.seedReturnService.isReturnTypeForInnoculant ? ['checkbox', 'product', 'itemNumber', 'uom', 'units', 'dumpedUnits', 'notes', 'approverNotes'] : ['checkbox', 'product', 'itemNumber', 'lotNumber', 'uom', 'units', 'dumpedUnits', 'notes'];
  isParent: boolean = false;
  requestOnBehalfList: any = [];
  requestedByUser: string;
  currentRequestedUser: string;
  shipToDataLoading: boolean = true;
  index: any;
  returnRequestNumber: number = 0;
  returnRequestId: number = 0;
  accountEmail: string;
  readOnlyAccess: boolean = false;
  userMenuAccessList: any;
  dsmInfo: string;
  dsmId: string;
  productList: any[];
  userIdRole: string;
  isApprovalAccess: boolean = false;
  createRequestAccess: boolean = false;
  editApprovalList: any = {};
  roleType: string;
  enableCreate: boolean = true;
  requestStatus: string;
  isValidLineStatus: boolean = false;

  isPickupDateValid: boolean = true;
  isNameValid: boolean;
  isContactValid: boolean;
  isPalletValid: boolean;
  isAllProductChecked: boolean = false;
  checkBoxCount: number = 0;

  showSubmitToJde: boolean = false;
  showSubmitReturn: boolean = false;
  breadcrumbtext: string;
  showScaleDelete: boolean = false;
  marketingBrandMasterList: any[];
  packageSizeMasterList: any = [];
  seedSizeMasterList: any = [];
  treatmentMasterList: any[];
  technologyMasterList: any[];
  showDelete: boolean = false;
  onBehalfUser: any;
  onBehalfUserName: string;
  selectedUserName: string;
  isRequestPending: boolean = true;;
  validateEvolveData: any;
  disableRejectedLine: boolean = true;
  isIncreaseQtyEnable: boolean = true;
  isDecreaseQtyEnable: boolean = true;
  selectedProductLineValue: string;
  selectedProductLineText: string;
  selectedProductLineId: string;
  mandatoryFieldSymbol: any = '';
  isShowNonSubEmail: boolean = true;
  isReturnTypeForInnoculant: boolean = false
  warningMessage: string = "";
  public desiredPickupDate: any;
  public contactName: string;
  public contactNumber: string;
  public customerPONumber: string = 'Return';
  public shippingInstructions: string;
  public selectedFreightInstruction: string;
  public selectedFreightInstructionName: string;
  public palletCount: number;
  public emptyPalletCount: number;
  public emptyBoxCount: number;
  public emptyPallet: string;
  public emptyCBox: string;

  private subscription = new Subscription();

  public rdProduct: boolean = null;
  public rdEmptyCBox: boolean = null;
  public rdEmptyPallet: boolean = null;
  public isShowPickInfo: boolean = false;

  constructor(
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private loaderService: LoaderService,
    private broadcastService: BroadcastService,
    private configService: ConfigService,
    private toastrService: ToastrService,
    public seedReturnService: SeedReturnService,
    public config: NgbDatepickerConfig,
    public configDate: NgbCalendar,
    private localStorageService: LocalStorageService,
    private commonService: CommonService) {
    this.dashboardFilter = new DashboardFilter();
  }

  ngOnInit() {
    this.requestStatus = this.seedReturnService.returnRequestStatus;
    if (this.localStorageService.get(MasterConstants.HEADER_CROP_YEAR)) {
      this.cropYear = JSON.parse(this.localStorageService.get(MasterConstants.HEADER_CROP_YEAR));
    }

    this.subscription.add(this.seedReturnService.SelectedProductLineId.subscribe(x => {
      if (x && x != '') {
        this.selectedProductLineValue = this.seedReturnService.getProductLineValueById(x);
        this.selectedProductLineText = this.seedReturnService.getProductLineTextById(x);
        this.selectedProductLineId = x;
      }
      else {
        this.router.navigate(['/seed-returns-dashboard/All']);
      }
    }));

    if (this.localStorageService.get(MasterConstants.EVOLVE_ACCESS)) {
      var data = JSON.parse(this.localStorageService.get(MasterConstants.EVOLVE_ACCESS));
      if (data !== null && data !== undefined && data.resultData.length > 0) {
        var isActiveUser = data.resultData.find(x => x.userIdCompanyCode == this.headerCompany);
        if (!isActiveUser.isSubscriptionAccess) {
          this.isShowNonSubEmail = false;
        } else {
          this.isShowNonSubEmail = true;
        }
        this.userIdRole = data.resultData.find(x => x.userIdCompanyCode == this.headerCompany).userIdRole;
        this.userMenuAccessList = data.resultData.find(x => x.userIdCompanyCode == this.headerCompany).userMenuAccessList;
        if (this.userMenuAccessList && this.userMenuAccessList.length > 0) {
          this.readOnlyAccess = this.commonService.checkUserRoleAccessType(MasterConstants.FUNCTION_CODE.RETURN_REQUEST_INVENTORY_PROTECTION, MasterConstants.USER_ACCESS.READ_ONLY, this.userMenuAccessList) || this.commonService.checkUserRoleAccessType(MasterConstants.FUNCTION_CODE.RETURN_REQUEST_IP_APPROVAL, MasterConstants.USER_ACCESS.READ_ONLY, this.userMenuAccessList);
          this.isApprovalAccess = this.commonService.checkUserRoleAccessTypeForMenu(this.userMenuAccessList, MasterConstants.FUNCTION_CODE.RETURN_REQUEST_IP_APPROVAL);
          this.createRequestAccess = this.commonService.checkUserRoleAccessTypeForMenu(this.userMenuAccessList, MasterConstants.FUNCTION_CODE.RETURN_REQUEST_INVENTORY_PROTECTION);
          this.isReturnTypeForInnoculant = this.seedReturnService.isReturnTypeForInnoculant

          if (this.isReturnTypeForInnoculant) {
            this.seedReturnService.getWarningMessage().subscribe((result: any) => {
              this.warningMessage = result.message
            });
          }
          this.roleType = data.resultData.find(x => x.userIdCompanyCode == this.headerCompany).roleType.toUpperCase();
          //Get Return Request Id from URL
          this.subscription.add(this.activatedRoute.params.subscribe(x => {
            this.errorMsgs = [];
            if (x["returnRequestId"]) {
              this.returnRequestId = +x["returnRequestId"];
              this.getOrderDetails();
            }
            else {
              this.enableCreate = true;
            }
          }))
        }
        this.enableCreate = true;
      }
    }

    //this.loadMasterData();
    this.productAllDataSource = new MatTableDataSource([]);
    this.seedReturnService.setEditModeStatus(false);
    this.errorMsgs = new Array();

    this.fetchReturnMasterData();
  }

  //Bind data source
  bindDataSource(orderList: any, isClone: boolean) {
    if (orderList && orderList != null) {
      this.productAllDataSource = new MatTableDataSource(orderList);
    }
  }

  // Added Window onresize
  @HostListener('window:resize', ['$event']) onresize(event) {
    this.setHeight();
  }

  //Design
  ngAfterViewInit() {
    // Set Dynamic Height of Panels
    this.setHeight();
  }

  //Design : Set height
  setHeight() {
    const createTemplateHeight = window.innerHeight - $('.navbar').outerHeight() - $('.SeedFulfillBtnSec').outerHeight();
    $('.create-return-outer').css('max-height', createTemplateHeight + 'px');
  }

  //Get Order Details when opened in Edit/View Mode
  getOrderDetails() {
    this.loaderService.setLoaderStatus(true);
    this.subscription.add(this.seedReturnService.getEditRequestDetail(this.returnRequestId).subscribe((result: any) => {
      this.breadcrumbtext = "Approve/Reject Return Request [" + result.returnRequestNumber + "]";
      this.seedReturnService.setEditModeStatus(true);
      this.isPickupDateValid = true;
      this.isNameValid = true;
      this.isContactValid = true;
      this.isPalletValid = true;
      this.seedReturnService.returnRequestStatus = result.returnRequestStatus;
      this.accountEmail = result.email;
      this.requestStatus = result.returnRequestStatus;
      this.enableCreate = false;
      this.editApprovalList = result;
      if (result.seedReturnProductList && result.seedReturnProductList.length > 0) {
        result.seedReturnProductList.forEach(x => {
          x.isSelected = false;
          x.eligibleUnit = x.isManualLine ? 0 : x.eligibleUnit;
          x.lineErrors = { "itemId": x.itemId, "lotNumber": x.lotNumber, "errors": [] };
          if (!this.isApprovalAccess && x.lineStatus == "PENDING") {
            x.isIncreaseQtyDisable = true;
            x.isDecreaseQtyDisable = true;
          }
          else if (!this.isApprovalAccess && x.lineStatus == "APPROVED") {
            x.isIncreaseQtyDisable = true;
          }
          if (this.isReturnTypeForInnoculant) {
            if (x.ipPercentage < 100 && x.returnQuantity > x.eligibleUnit) { x.isShowInoculantWarning = true }
            else { x.isShowInoculantWarning = false }
          }
        });
      }
      this.returnRequestNumber = result.returnRequestNumber;
      this.shipToAccount = result.shipToAccountId;
      this.shipToAccountName = result.shipToAccountName;
      this.seedReturnService.setSelectedAccountNo(this.shipToAccount);
      this.dsmInfo = result.dsmName;
      this.dsmId = result.dsmId;
      this.isParent = result.isParent;
      this.shipToAccountItems = [result.shipToAccountDetail];
      this.soldToAccount = Number(result.shipToAccountDetail.soldTo);
      this.seedReturnService.setProductList(result.seedReturnProductList);
      this.originalProductItemsDataSource = [];
      this.bindDataSource(result.seedReturnProductList, true);
      this.originalProductItemsDataSource = JSON.parse(JSON.stringify(result.seedReturnProductList));
      this.requestedByUser = result.requestedBy;
      this.onBehalfUser = result.requestedBy;
      this.getUserList(this.shipToAccount);

      this.rdProduct = result.productsToReturn;
      if (this.rdProduct === true) {
        this.mandatoryFieldSymbol = '';
      }
      else {
        this.mandatoryFieldSymbol = '*';
      }
      this.rdEmptyCBox = result.emptyCbox;
      this.rdEmptyPallet = result.emptyPallet;
      this.isShowPickInfo = this.rdProduct || this.rdEmptyPallet || this.rdEmptyCBox;

      this.seedReturnService.setSelectedAccountNo(result.shipToAccountId);
      var approvedItem = result.seedReturnProductList.filter(x => x.lineStatus == 'APPROVED');
      if (approvedItem.length > 0) {
        this.isRequestPending = false;
      }

      this.contactName = result.pickupInfo.contactName;
      this.contactNumber = result.pickupInfo.contactNumber;
      this.customerPONumber = result.pickupInfo.custPONumber;
      this.palletCount = result.pickupInfo.palletCount;
      this.emptyPalletCount = result.pickupInfo.emptyPalletCount;
      this.emptyBoxCount = result.pickupInfo.emptyCboxCount;
      this.desiredPickupDate = new Date(result.pickupInfo.requestDate);
      this.deliveryAccount = result.pickupInfo.pickUpLocation;
      this.deliveryAccountName = result.pickupInfo.pickUpLocationName;
      this.shippingInstructions = result.pickupInfo.shippingInstructions;
      this.selectedFreightInstruction = (result.pickupInfo.freightInstructions == null || result.pickupInfo.freightInstructions == "") ? "" : result.pickupInfo.freightInstructions;
      this.selectedFreightInstructionName = result.pickupInfo.freightInstructionsDescription;
      this.loaderService.setLoaderStatus(false);
    }, error => this.loaderService.setLoaderStatus(false)));
  }

  enableCheckBoxSingle(isChecked) {
    if (isChecked) {
      this.checkBoxCount = this.productAllDataSource.filteredData.filter(x => x.isSelected == true).length;
      let checked = this.productAllDataSource.filteredData.filter(x => x.isSelected == false);

      if (checked && checked.length == 0) {
        this.isAllProductChecked = true;
      }
      else {
        this.isAllProductChecked = false;
      }
    }
    else {
      this.checkBoxCount = this.checkBoxCount - 1;
      this.isAllProductChecked = false;
      let selected = this.productAllDataSource.filteredData.filter(x => x.isSelected == true);
    }
    let selectedItem = this.productAllDataSource.filteredData.filter(x => x.isSelected == true);
    this.isValidLineStatus = false;
    if (selectedItem.length > 0) {
      this.isValidLineStatus = selectedItem.filter(item => item.lineStatus == '' || item.lineStatus == null || item.lineStatus == 'DRAFT' || item.returnRequestItemId == 0).length > 0 ? true : false;
    }
  }

  getUserList(accountNumber) {
    var self = this;
    this.subscription.add(this.seedReturnService.getAccountUser(accountNumber).subscribe((result: any) => {
      if (result.length > 0) {
        result.filter(x => {
          var accountNameArr = x.userName.split(",");
          if (accountNameArr.length > 1) {
            x.userName = accountNameArr[1] + " " + accountNameArr[0];
          }
        });
        this.requestOnBehalfList = result;
        //if (this.currentRequestedUser) {
        //  let requestItem = this.requestOnBehalfList.filter(r => r.userId == this.currentRequestedUser);
        //  this.requestedByUser = requestItem[0].userId;
        //}
        if (this.onBehalfUser) {
          let requestItem = this.requestOnBehalfList.filter(r => r.userId == this.onBehalfUser);
          this.onBehalfUserName = requestItem[0].userName;
          this.accountEmail = this.isShowNonSubEmail ? this.accountEmail : requestItem[0].userEmail;
          this.requestedByUser = requestItem[0].userId;
        }

        if (self.onBehalfUser && self.requestOnBehalfList.filter(r => r.userId == self.onBehalfUser)[0] === undefined) {
          self.accountEmail = null;
          self.onBehalfUser = null;
        }
      }
    }, error => this.loaderService.setLoaderStatus(false)));
  }

  //Load master data
  //loadMasterData() {
  //  //get Item Number List
  //  if (this.localStorageService.get(MasterConstants.SEED_RETURN_ITEM_NUMBER_MASTER_LIST)) {
  //    this.invoicedProductList = JSON.parse(this.localStorageService.get(MasterConstants.SEED_RETURN_ITEM_NUMBER_MASTER_LIST));
  //  }
  //  this.subscription.add(this.seedReturnService.getAccountUser(0).subscribe((result: any) => {
  //    this.requestOnBehalfList = result;
  //    this.onBehalfUser = this.requestOnBehalfList[0].userId;
  //    this.accountEmail = this.requestOnBehalfList[0].userEmail;
  //    this.requestedByUser = this.requestOnBehalfList[0].userId;
  //    this.currentRequestedUser = this.requestOnBehalfList[0].userId;

  //  }, error => this.loaderService.setLoaderStatus(false)));

  //}

  fetchReturnMasterData() {
    if (this.headerCompany && this.selectedProductLineId) {
      this.subscription.add(this.seedReturnService.getReturnMaster(this.selectedProductLineId)
        .subscribe(result => {
          if (result) {
            this.emptyPallet = result.emptyPallet;
            this.emptyCBox = result.emptyCbox;
          }
        }, error => this.loaderService.setLoaderStatus(false))
      );
    }
  }

  backToRequest() {
    this.router.navigate(['/seed-returns/return-request', this.returnRequestId]);
  }

  // On page destroy
  ngOnDestroy() {
    this.seedReturnService.setReturnRequestId(0);
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }

  validateOrder() {
    var isValidatedCount = 0;
    if (this.productAllDataSource.data && this.productAllDataSource.data.length > 0) {
      this.productAllDataSource.data.forEach(x => {
        if (x.approverNotes == null || x.approverNotes == undefined || x.approverNotes == "") {
          isValidatedCount = isValidatedCount + 1;
        }
      });
    }
    return isValidatedCount > 0 ? false : true;
  }

  approvedJDERequest() {
    $('#returnRequestView').animate({ scrollTop: 0 }, 'slow');
    if (!this.validateOrder()) {
      this.toastrService.error("Approver Notes can't be Blank");
      return false
    }
    var newLineItems = [];
    this.editApprovalList.isUpdateRequest = true;
    this.productAllDataSource.data.filter(x => {
      newLineItems.push(JSON.parse(JSON.stringify(x)));
      x.lineStatus = 'APPROVED'
      x.errorMessage = null;
    });
    var productList = JSON.parse(JSON.stringify(this.productAllDataSource.data));

    let item = this.requestOnBehalfList.filter(r => r.userId == this.requestedByUser)[0];
    if (this.requestedByUser && item) {
      this.selectedUserName = item.userName;
    }

    this.editApprovalList.seedReturnProductList = productList;
    //this.editApprovalList.scaleTicketList = this.scaleTicketList;
    this.editApprovalList.email = this.accountEmail;
    this.editApprovalList.emailUserName = this.selectedUserName;
    this.editApprovalList.requestedBy = this.requestedByUser;
    this.editApprovalList.returnRequestStatus = 'APPROVED';
    this.editApprovalList.PickupInfo = {
      RequestDate: this.desiredPickupDate,
      ContactName: this.contactName,
      ContactNumber: this.contactNumber,
      PickUpLocation: this.deliveryAccount,
      ShippingInstructions: this.shippingInstructions,
      FreightInstructions: this.selectedFreightInstruction,
      PalletCount: Number(this.palletCount),
      EmptyPalletCount: Number(this.emptyPalletCount),
      EmptyCboxCount: Number(this.emptyBoxCount)
    };
    this.editApprovalList.ProductLine = this.selectedProductLineId
    //var isValidated = true;
    //if (this.validateJDEOrder()) {
    //var acceptedItem = productList.filter(x => x.lineStatus === 'APPROVED')[0];
    //if (acceptedItem === undefined) {
    //  this.toastrService.error('There is no approved line to Submit ');
    //  return;
    //}
    //this is submit request
    this.loaderService.setLoaderStatus(true);
    this.subscription.add(this.seedReturnService.submitToJDEReturnRequest(this.editApprovalList).subscribe((result: any) => {
      if (result) {
        let errorCount = result.seedReturnProductList.filter(x => x.errorMessage != null).length;
        if (errorCount > 0) {
          this.productAllDataSource.data = result.seedReturnProductList;
          this.productAllDataSource.data.forEach(x => {
            let item = newLineItems.filter(y => y.itemId == x.itemId && y.lotNumber == x.lotNumber);
            if (item.length > 0) {
              x.lineStatus = item[0].lineStatus;
            }
            this.originalProductItemsDataSource.find(data => data.itemId === x.itemId && data.lotNumber == x.lotNumber).lineError = x.lineError;
            this.originalProductItemsDataSource.find(data => data.itemId === x.itemId && data.lotNumber == x.lotNumber).isManualLine = x.isManualLine;
            //this.originalProductItemsDataSource.find(data => data.itemId === x.itemId && data.lotNumber == x.lotNumber).isManualLine = x.isManualLine;
            if (x.errorMessage != '' && x.errorMessage != null) {
              x.lineErrors = { "itemId": x.itemId, "lotNumber": x.lotNumber, "errors": [{ "error": x.errorMessage }] };
              x.lineError = true;
              this.errorMsgs.push(x.lineErrors);
            }
            else {
              x.lineErrors = { "itemId": x.itemId, "lotNumber": x.lotNumber, "errors": [] };
              x.lineError = true;
            }
          });
          this.loaderService.setLoaderStatus(false);
        } else {
          let successMsg = "Return Request has been approved."
          this.toastrService.success(successMsg);
          this.router.navigate([`/seed-returns/return-confirmation/${this.returnRequestNumber}`]);
          this.broadcastService.broadcast(this.configService.DATA_CHANGE, { updateButtonClick: true });
          this.loaderService.setLoaderStatus(false);
        }
      }
    }, error => {
      this.loaderService.setLoaderStatus(false);
      this.toastrService.error("Return Request not saved in the system.");
    }));
    //}
  }

  rejectedJDERequest() {
    $('#returnRequestView').animate({ scrollTop: 0 }, 'slow');
    if (!this.validateOrder()) {
      this.toastrService.error("Approver Notes can't be Blank");
      return false
    }
    var newLineItems = [];
    this.editApprovalList.isUpdateRequest = true;
    this.productAllDataSource.data.filter(x => {
      newLineItems.push(JSON.parse(JSON.stringify(x)));
      x.lineStatus = 'REJECTED'
      x.errorMessage = null;
    });
    var productList = JSON.parse(JSON.stringify(this.productAllDataSource.data));

    let item = this.requestOnBehalfList.filter(r => r.userId == this.requestedByUser)[0];
    if (this.requestedByUser && item) {
      this.selectedUserName = item.userName;
    }

    this.editApprovalList.seedReturnProductList = productList;
    //this.editApprovalList.scaleTicketList = this.scaleTicketList;
    this.editApprovalList.email = this.accountEmail;
    this.editApprovalList.emailUserName = this.selectedUserName;
    this.editApprovalList.requestedBy = this.requestedByUser;
    this.editApprovalList.returnRequestStatus = 'REJECTED';
    this.editApprovalList.PickupInfo = {
      RequestDate: this.desiredPickupDate,
      ContactName: this.contactName,
      ContactNumber: this.contactNumber,
      PickUpLocation: this.deliveryAccount,
      ShippingInstructions: this.shippingInstructions,
      FreightInstructions: this.selectedFreightInstruction,
      PalletCount: Number(this.palletCount),
      EmptyPalletCount: Number(this.emptyPalletCount),
      EmptyCboxCount: Number(this.emptyBoxCount)
    };
    this.editApprovalList.ProductLine = this.selectedProductLineId
    //var isValidated = true;
    //if (this.validateJDEOrder()) {
    //var acceptedItem = productList.filter(x => x.lineStatus === 'APPROVED')[0];
    //if (acceptedItem === undefined) {
    //  this.toastrService.error('There is no approved line to Submit ');
    //  return;
    //}
    //this is submit request
    this.loaderService.setLoaderStatus(true);
    this.subscription.add(this.seedReturnService.submitToJDEReturnRequest(this.editApprovalList).subscribe((result: any) => {
      if (result) {
        let errorCount = result.seedReturnProductList.filter(x => x.errorMessage != null).length;
        if (errorCount > 0) {
          this.productAllDataSource.data = result.seedReturnProductList;
          this.productAllDataSource.data.forEach(x => {
            let item = newLineItems.filter(y => y.itemId == x.itemId && y.lotNumber == x.lotNumber);
            if (item.length > 0) {
              x.lineStatus = item[0].lineStatus;
            }
            this.originalProductItemsDataSource.find(data => data.itemId === x.itemId && data.lotNumber == x.lotNumber).lineError = x.lineError;
            this.originalProductItemsDataSource.find(data => data.itemId === x.itemId && data.lotNumber == x.lotNumber).isManualLine = x.isManualLine;
            //this.originalProductItemsDataSource.find(data => data.itemId === x.itemId && data.lotNumber == x.lotNumber).isManualLine = x.isManualLine;
            if (x.errorMessage != '' && x.errorMessage != null) {
              x.lineErrors = { "itemId": x.itemId, "lotNumber": x.lotNumber, "errors": [{ "error": x.errorMessage }] };
              x.lineError = true;
              this.errorMsgs.push(x.lineErrors);
            }
            else {
              x.lineErrors = { "itemId": x.itemId, "lotNumber": x.lotNumber, "errors": [] };
              x.lineError = true;
            }
          });
          this.loaderService.setLoaderStatus(false);
        } else {
          let successMsg = "Return Request has been rejected."
          this.toastrService.success(successMsg);
          this.router.navigate([`/seed-returns/return-confirmation/${this.returnRequestNumber}`]);
          this.broadcastService.broadcast(this.configService.DATA_CHANGE, { updateButtonClick: true });
          this.loaderService.setLoaderStatus(false);
        }
      }
    }, error => {
      this.loaderService.setLoaderStatus(false);
      this.toastrService.error("Return Request not saved in the system.");
    }));
    //}
  }

  returnToDraft() {
    $('#returnRequestView').animate({ scrollTop: 0 }, 'slow');
    /*this.isSaveOrderDraftEnable = false;*/
    if (!this.validateOrder()) {
      this.toastrService.error("Approver Notes can't be Blank");
      return false
    }
    var newLineItems = [];
    this.productAllDataSource.data.filter(x => {
      newLineItems.push(JSON.parse(JSON.stringify(x)));
      x.lineStatus = 'DRAFT'
      x.errorMessage = null;
    });
    var productList = JSON.parse(JSON.stringify(this.productAllDataSource.data));
    var postData = {
      ReturnRequestId: this.returnRequestId,
      ReturnRequestType: this.selectedProductLineValue,
      ReturnRequestNumber: this.returnRequestNumber,
      ReturnRequestStatus: 'DRAFT',
      CompanyCode: this.headerCompany,
      ShipToAccountId: this.shipToAccount,
      IsUpdateRequest: this.seedReturnService.getEditModeStatus(),
      DsmId: this.dsmId,
      BranchPlant: null,
      SeedReturnProductList: productList,
      Email: this.accountEmail,
      RequestedBy: this.requestedByUser,
      ProductsToReturn: this.isReturnTypeForInnoculant ? true : this.rdProduct,
      EmptyCbox: this.rdEmptyCBox,
      EmptyPallet: this.rdEmptyPallet,
      isReturnToDraft: "1",
      PickupInfo: {
        RequestDate: (this.desiredPickupDate ? (new Date(this.desiredPickupDate)).toLocaleDateString() : null),
        ContactName: (this.contactName ? this.contactName : ""),
        ContactNumber: (this.contactNumber ? this.contactNumber : ""),
        PickUpLocation: (this.deliveryAccount ? this.deliveryAccount : null),
        ShippingInstructions: (this.shippingInstructions ? this.shippingInstructions : null),
        FreightInstructions: this.selectedFreightInstruction,
        PalletCount: (this.rdProduct && this.palletCount ? Number(this.palletCount) : null),
        EmptyPalletCount: (this.rdEmptyPallet && this.emptyPalletCount ? Number(this.emptyPalletCount) : null),
        EmptyCboxCount: (this.rdEmptyCBox && this.emptyBoxCount ? Number(this.emptyBoxCount) : null),
        CustPONumber: (this.customerPONumber ? this.customerPONumber : "")
      },
      ProductLine: this.selectedProductLineId
    }
    this.loaderService.setLoaderStatus(true);

    this.seedReturnService.submitReturnRequest(postData).subscribe((result: any) => {
      if (result) {
        if (result.errors.length > 0) {
          this.loaderService.setLoaderStatus(false);
          result.errors.forEach(x => {
            this.toastrService.error(x);
            return false;
          });
        }
        else {
          let errorCount = result.seedReturnProductList.filter(x => x.errorMessage != null).length;
          if (errorCount > 0) {
            this.productAllDataSource.data = result.seedReturnProductList;
            this.productAllDataSource.data.forEach(x => {
              let item = newLineItems.filter(y => y.itemId == x.itemId && y.lotNumber == x.lotNumber);
              if (item.length > 0) {
                x.lineStatus = item[0].lineStatus;
              }
              if (x.errorMessage != '' && x.errorMessage != null) {
                x.lineErrors = { "itemId": x.itemId, "lotNumber": x.lotNumber, "errors": [{ "error": x.errorMessage }] };
                this.errorMsgs.push(x.lineErrors);
              }
              else {
                x.lineErrors = { "itemId": x.itemId, "lotNumber": x.lotNumber, "errors": [] };
              }
            });
            this.loaderService.setLoaderStatus(false);
          } else {
            let successMsg = "Return Request has been changed to draft status.";
            this.toastrService.success(successMsg);

            this.router.navigate([`/seed-returns-dashboard/${this.selectedProductLineValue}`]);

            this.broadcastService.broadcast(this.configService.DATA_CHANGE, { updateButtonClick: true });
            this.loaderService.setLoaderStatus(false);
          }
        }
      }
    }, error => {
      this.loaderService.setLoaderStatus(false);
      this.toastrService.error("Return Request not saved in the system.");
    });
  }

  // Generate PDF
  generatedPdf() {
    this.seedReturnService.generatePdf(this.returnRequestId);
  }
}
